import React, { useState, useEffect, useRef } from "react";
import "./Clani.css";
import { useTranslation } from "react-i18next";
import { FaUserTie } from "react-icons/fa";

const members = [
  { img: "/Slike/Clani/magdalena2.webp", name: "Magdalena Navodnik", clanstvo: "Ustanovni član : 2005",  misel:"- Let's be the change. Now!", alt:"Magdalena Navodnik" },
  { img: "/Slike/Clani/franc.webp", name: "Franc Meža", clanstvo: "Ustanovni član : 2005", misel:"O", alt:"Franc Meža"  },
  { img: "/Slike/Clani/narcis.webp", name: "Narcis Kantardžič", clanstvo: "Ustanovni član : 2005", misel:"O", alt:"Narcis Kantardžič" },
  { img: "/Slike/Clani/borut1.png", name: "Borut Sitar", clanstvo: "Ustanovni član : 2005",  misel:"O", alt:"Borut Sitar"  },
  { img: "/Slike/Clani/jozko1.webp", name: "Jožko Gregorovič", clanstvo: "Član od leta : 2006", misel:"- Gibalo človeškega razvoja je človeška lenoba.", alt:"Jožko Gregorovič" },
  { img: "/Slike/Clani/jozef1.webp", name: "Jožef Kočevar", clanstvo: "Član od leta : 2016",  misel:"- Per Angusta Ad Augusta", alt:"Jožef Kočevar" },
  { img: "/Slike/Clani/nemanja.webp", name: "Nemanja Lubarda", clanstvo: "Član od leta : 2008",  misel:"O", alt:"Nemanja Lubarda" },
  { img: "/Slike/Clani/darjo.webp", name: "Darjo Pungartnik", clanstvo: "Član od leta : 2007",  misel:"O", alt:"Darjo Pungartnik" },
  { img: "/Slike/Clani/katja3.webp", name: "Dr. Katja Bizaj", clanstvo: "Član od leta : 2024",  misel:"- Raj na zemlji ni kraj, ki ga iščemo, temveč izbira, ki jo ustvarjamo.", alt:"Katja Bizaj"  },
  { img: "/Slike/Clani/miroslav.webp", name: "Doc.dr. Miroslav Žaberl", clanstvo: "Član od leta : 2013 ",  misel:"O", alt:"Miroslav Žaberl" },
  { img: "/Slike/Clani/primoz1.png", name: "Primož Temnik", clanstvo: "Član od leta : 2021 ",  misel:"O", alt:"Primož Temnik" },
  { img: "/Slike/Clani/bostjan1.png", name: "Boštjan Pražnikar", clanstvo: "Član od leta : 2020",  misel:"O", alt:"Boštjan Pražnikar"  },
  { img: "/Slike/Clani/dejan.webp", name: "Dejan Pehar", clanstvo: "Član od leta : 2021 ",  misel:"O", alt:"Dejan Pehar"  },
  { img: "/Slike/Clani/andrej1.png", name: "Andrej Bizaj", clanstvo: "Član od leta : 2024",  misel:"O", alt:"Andrej Bizaj"  },
  { img: "/Slike/Clani/blanka2.png", name: "Blanka Nerad", clanstvo: "Član od leta : 2019" ,  misel:"O", alt:"Blanka Nerad" },
  { img: "/Slike/Clani/aljazv.webp", name: "Aljaž Vrabič", clanstvo: "Član od leta : 2024 ",  misel:"O", alt:"Aljaž Vrabič"  },
  { img: "/Slike/Clani/pangerl.webp", name: "Franc Pangerl", clanstvo: "Častni član",  misel:"Častni član", alt:"Franc Pangerl" },
  { img: "/Slike/Clani/marovt.webp", name: "Boštjan Marovt", clanstvo: "Častni član",  misel:"Častni član", alt:"Boštjan Marovt" },
  { img: "/Slike/Clani/matjaz.webp", name: "Matjaž Pavčič", clanstvo: "Častni član",  misel:"Častni član", alt:"Matjaž Pavčič" },
  { img: "/Slike/Clani/zan.webp", name: "Žan Nerad", clanstvo: "Član od leta : 2024",  misel:"- Verjamem, da vsak od nas lahko prinese svetlobo v življenje drugega.", alt:"Žan Nerad"  },
  { img: "/Slike/Clani/aljaz.webp", name: "Aljaž Nerad", clanstvo: "Član od leta : 2025",  misel:"O", alt:"Aljaž Nerad" },
  { img: "/Slike/Clani/oscar1.webp", name: "Oscar Gregorovič", clanstvo: "Član od leta : 2025",  misel:"- Gibalo človeškega razvoja je medsebojna potrpežljivost.", alt:"Oscar Gregorovič" },
  { img: "/Slike/Clani/anita.webp", name: "Anita Napotnik", clanstvo: "Član od leta : 2025",  misel:"O", alt:"Anita Napotnik" },
   { img: "/Slike/Clani/uros.png", name: "Uroš Kristan", clanstvo: "Član od leta : 2026",  misel:"O", alt:"Uroš Kristan" },
];

const Clani = () => {
  const { t } = useTranslation();
  const [activeIndex, setActiveIndex] = useState(null);
  const [visible, setVisible] = useState(false);
  const containerRef = useRef(null);

  const handleClick = (index) => {
    setActiveIndex((prev) => (prev === index ? null : index));
  };

  useEffect(() => {
    const target = containerRef.current;
    if (!target) return;

    // 1) If it's already in view on first paint → show immediately
    const rect = target.getBoundingClientRect();
    if (rect.top < window.innerHeight) {
      setVisible(true);
      return; // no need to set up observers/listeners
    }

    // 2) Otherwise, use IntersectionObserver when available
    if (typeof window !== "undefined" && "IntersectionObserver" in window) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setVisible(true);
            observer.disconnect();
          }
        },
        { threshold: 0.25 }
      );

      observer.observe(target);
      return () => observer.disconnect();
    }

    // 3) Fallback: scroll listener (passive, removed after first trigger)
    const handleScroll = () => {
      if (!containerRef.current) return;
      const r = containerRef.current.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.75) {
        setVisible(true);
        window.removeEventListener("scroll", handleScroll);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div>
      <div style={{ textAlign: "center" }}>
        <p className="clanitext">
          <FaUserTie className="member-icon" size={20} />{" "}
          {t("total_members", { count: members.length })}
        </p>
      </div>

      <div
        ref={containerRef}
        className={`clanigallerycontainer ${visible ? "visible" : "hidden"}`}
      >
        {members.map((member, index) => {
          const isAboveTheFold = index < 6; // first 6 images load eagerly

          return (
            <div
              className="clanigalleryitem"
              key={member.name}
              onClick={() => handleClick(index)}
            >
              <div className="clanigalleryimage-container">
                <img
                  src={member.img}
                  alt={member.alt}
                  className="clanigalleryimage"
                  loading={isAboveTheFold ? "eager" : "lazy"}
                />
                <div
                  className={`misel-overlay ${
                    activeIndex === index ? "visible" : "hidden"
                  }`}
                >
                  {member.misel}
                </div>
              </div>
              <div className="clanigallerytext">
                {activeIndex === index ? member.clanstvo : member.name}
              </div>
            </div>
          );
        })}
      </div>

      <div style={{ textAlign: "center" }}>
        <div className="candidate" />
        <div className="vspomincrta" />
        <div className="vspomin">
          <h3 className="spomin-title">{t("in_memory")}</h3>
          <p className="spomin-description">{t("in_memory_desc")}</p>
          <img
            src="/Slike/Clani/stanislav.webp"
            alt="Stanislav Veniger"
            className="in-memory"
            loading="lazy"
          />
          <p className="image-caption">
            Stanislav Veniger, Ustanovni član : 2005
          </p>
        </div>
        <div className="vspomincrta" />
      </div>
    </div>
  );
};

export default Clani;
